export default "__VITE_ASSET__COmzMtpl__"